import { render, staticRenderFns } from "./LedgerEdit.vue?vue&type=template&id=84f55336&"
import script from "./LedgerEdit.vue?vue&type=script&lang=js&"
export * from "./LedgerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports